import { render, staticRenderFns } from "./ShapeSelection.vue?vue&type=template&id=3a23db58&scoped=true&"
import script from "./ShapeSelection.vue?vue&type=script&lang=ts&"
export * from "./ShapeSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ShapeSelection.vue?vue&type=style&index=0&id=3a23db58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23db58",
  null
  
)

export default component.exports